import IconMosqueSvg from '@assets/images/svg/icon-mosque.svg';
import React from 'react';
import { View } from 'react-native';

export interface IconMosqueIconProps {
    size?: number;
    color?: string;
}

export function IconMosqueIcon({ size = 23, color = '#4D4D4D' }: IconMosqueIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <IconMosqueSvg width={size} height={size} color={color} />
        </View>
    );
}

export default IconMosqueIcon;
